import { STEP } from "#src/constants/step.ts";

import { defineStore } from "#src/stores/state-wrapper.js";
import { PRODUCTS } from "#src/constants/products.ts";

import { useStepBuildStore } from "#src/stores/step-build.js";
import { useInstanceSettingsStore } from "#src/stores/instance-settings.js";
import { useStepQuoteStore } from "#src/stores/step-quote.js";
import { useStepBenefitEstimationStore } from "#src/stores/step-benefit-estimation.js";
import { useStepPreQuoteInformationStore } from "#src/stores/step-pre-quote-information.js";
import { useStepLifePriorityStore } from "#src/stores/step-life-priority.js";
import { useStepCompareStore } from "#src/stores/step-compare.js";
import { useBirthdateForm } from "#src/components/steps/birthdate/birthdate-form.composable.js";
import { REQS } from "#src/constants/data-requirements.ts";
import { arrayOnlyContains } from "#src/util/helpers.js";

export const useStepBirthdateStore = (pinia, hot) =>
  defineStore("step-birthdate", {
    state: () => ({ inactive: false }),
    getters: {
      step: () => STEP.BIRTHDATE,
      previous: () => {
        const build = useStepBuildStore(pinia);
        if (build.inactive) return build.previous;
        return build.step;
      },
      next() {
        const instanceSettingsStore = useInstanceSettingsStore(pinia);

        const quote = useStepQuoteStore(pinia);
        const types = instanceSettingsStore.available.map(
          v => v.subtype || v.type
        );
        if (
          arrayOnlyContains(types, [PRODUCTS.ACCIDENTAL_DEATH]) ||
          arrayOnlyContains(types, [PRODUCTS.FINAL_EXPENSE]) ||
          arrayOnlyContains(types, [
            PRODUCTS.ACCIDENTAL_DEATH,
            PRODUCTS.FINAL_EXPENSE,
          ])
        ) {
          return quote.step;
        }

        const benefitEstimation = useStepBenefitEstimationStore(pinia);
        if (
          arrayOnlyContains(types, [PRODUCTS.WHOLE_LIFE]) ||
          arrayOnlyContains(types, [PRODUCTS.ACCUMULATION_IUL])
        ) {
          return benefitEstimation.step;
        }

        const preQuoteInformation = useStepPreQuoteInformationStore(pinia);
        if (arrayOnlyContains(types, [PRODUCTS.INCOME_RIDER])) {
          return preQuoteInformation.step;
        }

        const lifePriority = useStepLifePriorityStore(pinia);
        if (lifePriority.availablePriorities.length > 1) {
          return lifePriority.step;
        }

        if (instanceSettingsStore.onlyOnePermanentProduct) return quote.step;

        const compare = useStepCompareStore(pinia);
        return compare.step;
      },
    },
    actions: {
      generateForm(module, args) {
        return useBirthdateForm(pinia, module, args);
      },
      setStepRequirements(srq) {
        this.inactive = !srq[REQS.INSURED_BIRTHDATE];
      },
    },
  })(pinia, hot);
